import * as Yup from "yup";
import i18n from "../i18n";

export const StartEvacuationSchema = Yup.object({
  location: Yup.string().required(
    i18n.language === "en" ? "Location is required" : "الموقع مطلوب",
  ),
  building: Yup.string(),
  floor: Yup.string(),
});

export interface StartEvacuationFormData {
  location: string;
  building?: string;
  floor?: string;
}